export default {
    url: '/add',
    template: '<user-skill-add-skill/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/skill/add/skill/index.js